import _ from 'lodash'

/**
 * Analogous to {@link com.spider.cms.datasets.DatasetUtils}
 */

/**
 * Removes any characters that are not allowed in a column name in the
 * [DatasetNamer.intermediate] table. This includes the characters:
 * - ] (right square bracket)
 * - [ (left square bracket)
 * Lowercases the column name.
 * @param column {string}
 * @returns {string}
 */
function getIntermediateTableColumnName(column) {
	if (_.isNil(column)) {
		return null
	}
	return column
		.replace('[', ' ')
		.replace(']', ' ')
		// trim any whitespace from the ends
		.trim()
		.toLowerCase()
}

export {
	getIntermediateTableColumnName
}